/**
 * The two leaf helpers every extractor module shares. A leaf on purpose:
 * extractor-yaml (outline, coverage, tokenizer) re-exports them, and
 * extractor-events (buckets, simulator) imports them directly, so neither
 * module needs the other.
 */

/** Python `(?P<name>…)` → JS `(?<name>…)`; a bad pattern yields null rather than a throw. */
export function toJsRegex(src: string, flags = ''): RegExp | null {
  try {
    return new RegExp(src.replace(/\(\?P</g, '(?<'), flags)
  } catch {
    return null
  }
}

/** Fields the engine stamps on every event regardless of the YAML. */
export const SYSTEM_FIELDS = new Set([
  'SourceName', 'SourceType', 'ExtractorID', 'PStatus', 'EvtLen', 'LogEvent', 'CNAMTime',
  'System', 'SystemTstamp', 'EStatus', 'EventName', 'Type', 'Stream',
])
